/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * LoginIcon - Auto-generated from icon.js
 */
export const LoginIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 1024 1024"
		// eslint-disable-next-line react/style-prop-object
		{...props}
	>
		<path
			d="M999.4 81.9h-722.9c-13.3 0-24.6 10.2-24.6 23.6 0 12.3 11.3 23.6 24.6 23.6h697.3v760.8h-697.3c-13.3 0-24.6 10.2-24.6 23.6 0 12.3 11.3 23.6 24.6 23.6h722.9c13.3 0 24.6-10.2 24.6-23.6v-808c0-13.3-11.3-23.6-24.6-23.6v0z"
		/>
		<path d="M376.1 396.5c-9.2-9.2-9.2-23.6 0-32.8 5.1-4.1 11.3-7.2 17.4-7.2s12.3 2 17.4 7.2l153.6 142.3c9.2 9.2 9.2 23.6 0 32.8l-152.6 142.4c-9.2 9.2-25.6 9.2-34.8 0s-9.2-23.6 0-32.8l110.6-102.4h-462.9c-13.3 0-24.6-10.2-24.6-23.6 0-12.3 11.3-23.6 24.6-23.6h461.8l-110.5-102.3z" />
	</svg>
);

export default LoginIcon;
